import Vue from 'vue';

if (Raven && Raven.H) {
  Vue.config.errorHandler = function (error) {
    Raven.captureMessage(`${error.name} - ${error.message}`, {
      level: 'error',
      logger: 'error',
      extra: {
        stack: error,
      },
    });
  };
}
